export const paths = {
  front: {
    commonPoint: "/ltwnh",
    user: {
      commonPoint: "user",
      dashboard: "dashboard",
      paymentStatus: "payment-status",
      finalconfirmation: "form-preview",
      confirmPayment: "confirm-payment",
      printApplication: "print-confirm",
      confirmApplication: "confirm-application",
      cancelApplication: "cancel-application",
    },

    objection: {
      // objectionLogin: "objection-login",
      objectionLogin: "result-out-login",
      user: {
        objections: "objections",
        objectionStepper: "objection-stepper",
        objectionPaymentStatus: "objection-payment-status",
      },
      objectionInfo: "objection-info",
      objectionPersonalInfo: "objection-personal-info",
    },

    admitCard: {
      login: "admit-card-login",
      user: {
        admitcardpreview: "admit-card-preview",
      },
    },

    resetPassword: "reset-password/:token",
    login: "login",
    register: "apply-exam",
    forgotPassword: "forgot-password",
    contactUs: "contact-us",
    howToApply: "how-to-apply",
    importantDates: "important-dates",
    admitcard: "admit-card",
    notification: "notification",
    helpdesk: "help-desk",
    logininstruction: "login-info",
    omrsheet: "omr-sheet",
  },
  admin: {
    commonPoint: "/TqOKA/admin",
    user: {
      commonPoint: "user",
      dashboard: "dashboard",
      candidates: "candidates",
      printView: "print-view",
      printAdmitCard: "print-admit-card",
      reUploadImage: "re-upload-image",
      downloadData: "download-data",
      payment: "payment",
      degree: "degree",
      candidateInfo: "candidate-data",
      subject: "subject",
      adminobjection: "objection",
      candidatereport: "candidate-report",
      questionimgreport: "question-image-report",
      questionreport: "question-report",
      objectionDocuments: "objectionDocuments",
    },
    login: "login",
    register: "register",
    forgotPassword: "forgot-password",
    resetPassword: "reset-password/:token",
  },
};

export const apisPath = {
  admin: {
    search_by: "search_by",
    dashboard: "dashboard",
    dashboardCards: "dashboard_cards",
    printApplication: "print_application",
    login: "login",
    payment: "payments",
    viewApplicationDetail: "view_application_detail",
    reUploadImageList: "re_images_list",
    uploadImage: "re_upload_image",
    printAdmitCard: "admit-card-details",
    getQualification: "qualifications_list",
    getDegree: "degree_list",
    getSubject: "subject",
    addDegree: "add_degree",
    addSubject: "add_subject",
    deleteDegree: "degree",
    deleteSubject: "delete_subjects",
    resetPassword: "reset_password",
    questionWiseObjections: "question-wise-report",
    getPapers: "getPapers",
    getPapersSet: "question-booklet-master",
    getPaperQuestion: "question-master",
    allObjectionDetails: "all-objections-details",
    candidateWiseObjections: "candidate-wise-report",
    questionImgWiseObjections: "detailed-wise-report",
    getObjectionDocument: "get-objection-document",
    // getPaidData: 'paid_data',
    // getNotPaidData: 'not_paid_data',
    // getEducationPaidData: 'education_data',
    // getEducationNotPaidData: 'education_not_paid_data',
    // getCancelledData: 'cancelled_data'
    downloadCandidateData: "candidate-excel-data-download-optimised",
    downloadEducationData: "education-candidate-excel-data-download",
    downloadEducationDataRowWise:
      "education-row-wise-candidate-excel-data-download",
    downloadData: "candidate-excel-data-downloaded-optimised-result",
  },
  // admin: {
  //     login: '/user-login',
  //     register: '/user-registration',
  //     forgotPassword: '/forgot/password',
  //     resetPassword: '/reset-password',
  //     checkToken: '/check-token',

  //     getRoles: '/get-roles',

  //     createUser: '/user-create',
  //     updateUser: '/user-update',
  //     getUsers: '/user-list',
  //     getUserById: '/get-user-details/',
  //     deleteUsers: '/multi-delete',

  //     getCandidates:'/candidate/list',

  //     createExamForm: '/examination/form-master',
  //     templateList: '/template-list',
  //     createTemplate: '/template/create',
  //     getExamForm: '/template/get-form-master/',

  //     createExam: '/examination/create',
  //     updateExam: '/examination/update',
  //     getExams: '/examination/list',
  //     getExamById: '/examination/details/',
  //     deleteExams: '/examination/multi-delete',
  //     getPublishExams: '/publish/examination-list',

  //     getCriteriaById: '/rules/details/',
  //     createCriteria: '/rules/create',
  //     updateCriteria: '/rules/update',

  //     createNotification: '/notification/create',
  //     updateNotification: '/notification/update/',
  //     getNotifications: '/notification-list',
  //     getNotificationById: '/notification/details/',
  //     deleteNotifications: '/notification/multi-delete',

  //     createDashItem: '/dash-slider/create',
  //     updateDashItem: '/dashboard/update/',
  //     getDashItems: '/get-dashboard',
  //     getDashItemById: '/dash-dashboard/get/',
  //     deleteDashItems: '/dashboard/delete',

  //     getObjections: '/objection/list',
  //     createObjReply: '/objection/reply/',
  //     viewObjHistory: '/objection/history/'
  // },
  front: {
    login: "/login",
    register: "/candidate-registration",

    categoryMaster: "/category/list/",
    religionMaster: "/religion/list",
    postMaster: "/post/list",
    degreeListMaster: "/degree/list/",
    stateMaster: "/state/list",
    districtMaster: "/district/list/",
    officeMaster: "/offices/list",
    certificateIssueMaster: "/certificate-issue/list",
    vacancyCheckCategoryBasis: "/post/vacancy/list/",
    qualificationMaster: "/qualification/list",
    gradeList: "/grade/list",
    subjectMaster: "/subject/list/",
    unversityMaster: "/uni-board/list/",
    marksTypeMaster: "/marks-type/list",
    qualificationCreate: "/qualification-create",
    qualificationGet: "/get-qualifications",
    qualificationDelete: "/delete-qualification/",
    qualificationUpdate: "/update-qualification",
    preferenceMaster: "/preference/list/",
    identityMaster: "/identity-proof/list",
    organizationTypeMaster: "/organisation/list",

    forgotPassword: "/forgot/password",
    resetPassword: "/reset-password",
    checkToken: "/check-token",
    notificationMaster: "/notification/list",
    importantDates: "/important-dates-list",
    addEductionDetails: "/candidate-examination-details",
    getEducationDetails: "/education-details",
    previewCandidateData: "/preview-candidate-data",
    isApplicaionOpen: "/application-open",
    getAge: "/age-calculation",

    // getNotifications: '/notification-list',
    // getNotificationById: '/notification/details/',

    // getExams: '/examination-list',
    // getExamById: '/exam-details/',

    // getDashItems: '/get-dashboard',

    user: {
      getBasicInfo: "/candidate-details",
      updateBasicInfo: "/update-personal-details",
      uploadDocs: "/upload-photo-signature",
      getDocs: "/get-photo-signature",
      getCompletedStep: "/complete-step",
      getPaymentDetail: "get-payment-details",
      cancelApplication: "candidate-cancel",
      getOtp: "candidate-cancel-otp",
      employmentOffices: "employment-offices/list",
      verifyImage: "/verify-image",
      logout: "/logout",
    },
    objection: {
      login: "objection/login",
      user: {
        getCompletedStep: "objection/completed-step",
        getPapers: "objection/candidate-paper-wise-objection-status",
        // getCandidateDetails:'objection/getCandidateInfo',
        getSelectedData: "objection/current-objection-details",
        getSubjects: "objection/subject-master",
        getQuesBoookletSeries: "objection/question-booklet-master/",
        updateBookletSeries: "objection/objection-basic-details",
        getQuestions: "objection/question-master",
        addObjection: "objection/create-objection",
        deleteObjection: "objection/delete/",
        getUnpaidObjection: "objection/unpaid-objections",
        getprevObjections: "objection/previous-objections",
        getPaymentURL: "objection/ccavRequestHandler",
        getOptions: "objection/option-master",
        getPaymentDetails: "objection/payment-slip",
      },
    },
    admitCard: {
      login: "login-payment-success",
      loginWithName: "login-with-name",
      loginWithApplicationNo: "login-with-application",
      user: {
        candidateDetails: "admit-card-details",
        counter: "download-admit-card-count",
      },
    },
  },
};
